import { useTranslation } from "react-i18next";
import { AddBoxOutlined } from "@mui/icons-material";
import { Alert, Button, Divider, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import { ColumnDialogMode, ColumnDialogParams } from "components/tables/columns/ColumnModel";

interface QueryComparisonTableToolbarProps {
  canAddColumn?: boolean;
  onColumnDialogMode: (params: ColumnDialogParams) => void;
  onBulkAddFieldOptions: (fieldTitle: string) => void;
  usuableFields?: string[] | [];
}

export default function QueryComparisonTableToolbar(props: QueryComparisonTableToolbarProps) {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(700));

  return (
    <>
      <Stack
        direction="row"
        sx={{
          width: "100%",
          justifyContent: isSmallScreen ? "space-between" : "center"
        }}>
        <>
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              gap: 1,
              width: "100%"
            }}>
            {!props.canAddColumn && <Alert severity="warning">{i18n.t("widget-types.query-comparison-table.settings.max-fields-allowed")}</Alert>}
            <Button
              color="success"
              disabled={!props.canAddColumn}
              variant="contained"
              startIcon={<AddBoxOutlined />}
              sx={{ marginLeft: "auto" }}
              onClick={() => {
                props.onColumnDialogMode && props.onColumnDialogMode({ mode: ColumnDialogMode.ADD_COLUMN });
              }}
            >
              {i18n.t("tables.add-column")}
            </Button>
          </Stack>
        </>
      </Stack>
      <Divider sx={{ marginTop: 1, marginBottom: 1 }} />
      <Alert
        severity="info"
        sx={{ ".MuiAlert-icon": { alignItems: "center" }, ".MuiAlert-message": { width: "100%" } }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            width: "100%"
          }}>
          <Typography sx={{ marginRight: "auto" }}>{i18n.t("widgets.settings.quick-presets")}</Typography>
          <Button variant="outlined" onClick={() => props.onBulkAddFieldOptions("sentiment")}>{i18n.t("sentiment")}</Button>
          <Button variant="outlined" onClick={() => props.onBulkAddFieldOptions("emotions")}>{i18n.t("emotions")}</Button>
          <Button variant="outlined" onClick={() => props.onBulkAddFieldOptions("gender")}>{i18n.t("gender")}</Button>
        </Stack>
      </Alert>
    </>
  );
}
